/** Used until the Owner sets `VITE_WEBSITE_URL` at build time (T410/T551). */
export const DEFAULT_WEBSITE_URL = "https://kestly.com.au"

/**
 * The marketing origin. Only a valid https URL is accepted; anything else falls back to the
 * default so a typo can never produce broken canonicals or sitemap URLs.
 */
export function resolveWebsiteUrl(value: string | undefined, strict = false): string {
  if (!value?.trim()) return DEFAULT_WEBSITE_URL
  try {
    const url = new URL(value.trim())
    if (url.protocol === "https:") return url.origin
  } catch {
    // handled below
  }
  // A silent fallback would mark the real host noindex, so production builds fail loudly.
  if (strict) throw new Error(`VITE_WEBSITE_URL must be an https URL, got "${value}"`)
  return DEFAULT_WEBSITE_URL
}
